import { render, staticRenderFns } from "./ModalRejectPayment.vue?vue&type=template&id=5702721d&scoped=true&"
import script from "./ModalRejectPayment.vue?vue&type=script&lang=js&"
export * from "./ModalRejectPayment.vue?vue&type=script&lang=js&"
import style0 from "./ModalRejectPayment.vue?vue&type=style&index=0&id=5702721d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5702721d",
  null
  
)

export default component.exports